import axios from "axios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const sendEmailCarrier = async (data) => {
  return axios.post(`${api_base_url}/email/sendEmail/`, data).then((res) => {
    return res;
  });
};

export const sendEmailAgreement = async (data) => {
  return axios
    .post(`${api_base_url}/email/sendEmailAgreement/`, data)
    .then((res) => {
      return res;
    });
};

export const sendEmailOfficeSettings = async (data) => {
  return axios
    .post(`${api_base_url}/email/sendEmailOfficeSettings/`, data)
    .then((res) => {
      return res;
    });
};

export const sendEmailProducerCode = async (data) => {
  return axios.post(`${api_base_url}/email/sendEmail/`, data).then((res) => {
    return res;
  });
};

export const sendEmailOfficeHierarchy = async (data) => {
  return axios
    .post(`${api_base_url}/email/sendEmailOfficeHierarchy/`, data)
    .then((res) => {
      return res;
    });
};
export const sendEmailEmployee = async (data) => {
  return axios
    .post(`${api_base_url}/email/sendEmailEmployee/`, data)
    .then((res) => {
      return res;
    });
};
export const sendEmailScoreCard = async (data) => {
  return axios
    .post(`${api_base_url}/email/sendEmailScoreCard/`, data)
    .then((res) => {
      return res;
    });
};
